import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetAuditLogs = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
  searchTerm
) => {
  setLoading(true);
  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/audit-logs`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage: 10,
        institutionId: institutionId,
        searchKey: searchTerm,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching audit logs: ", error);
    return error;
  }
};
